<!-- Delete Confirmation Modal -->
@if (!isNotDelete) {
  <div class="confirm-container">
    <div class="confirm-icon" aria-hidden="true">
      <svg viewBox="0 0 24 24" width="26" height="26" fill="none">
        <path d="M12 3 1.5 21h21L12 3Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
        <path d="M12 9.5v5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
        <circle cx="12" cy="17" r="1" fill="currentColor" />
      </svg>
    </div>
    <h4 class="confirm-title">Delete Confirmation</h4>
    <p class="confirm-body">Are you sure you want to delete this {{ pagename }}?</p>
    <div class="btn-wrapper">
      <button type="button" class="btn btn-outline" [disabled]="isLoading" (click)="closemodel()">Cancel</button>
      <button type="button" class="btn btn-danger" [disabled]="isLoading" (click)="deleteCharacter()">
        @if (isLoading) {
          <span class="confirm-spinner" aria-hidden="true"></span>
        }
        Delete
      </button>
    </div>
  </div>
}

<!-- City Entry Modal -->
@if (isNotDelete) {
  <div class="confirm-container">
    <div class="confirm-icon confirm-icon--info" aria-hidden="true">
      <svg viewBox="0 0 24 24" width="26" height="26" fill="none">
        <circle cx="12" cy="12" r="9.2" stroke="currentColor" stroke-width="1.6" />
        <path d="M12 11v5.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
        <circle cx="12" cy="7.6" r="1" fill="currentColor" />
      </svg>
    </div>
    <h4 class="confirm-title">Enter The City?</h4>
    <p class="confirm-body">Do you want to enter this city?</p>
    <div class="btn-wrapper">
      <button type="button" class="btn btn-outline" (click)="closemodel()">Cancel</button>
      <button type="button" class="btn btn-theme" (click)="deleteCharacter()">Yes</button>
    </div>
  </div>
}
